<script>
import { _ } from "svelte-i18n";

    import {
        navigateToCulture,
        navigateToLetters,
        navigateToNature,
        navigateToWorld,
    } from "../helper/Router";
    const allGradients = [
        "from-gradient_nature1",
        "to-gradient_nature2",
        "from-gradient_culture1",
        "to-gradient_culture2",
        "from-gradient_world1",
        "to-gradient_world2",
    ];
</script>

<style>
</style>

<section>
    <div class="container mx-auto px-1 lg:px-4 text-center">
        <h1 class="text-xl">
            {$_("login.welcome")}
        </h1>
        <div class="flex center flex-wrap px-1 lg:px-4">
            <div
                class="p-0  md:w-6/12 lg:w-6/12 flex flex-wrap w-full glass
                transition duration-500 ease-in-out uppercase
                text-gray-600  bg-transparent border rounded-full transform 
                 hover:bg-gradient1 hover:-translate-y-1 hover:scale-110
                 focus:bg-gradient2 focus:-translate-y-1 focus:scale-110
                ">
                <button on:click={navigateToLetters} class="w-full h-20">
                    {$_("main.toLetters")}</button>
            </div>
            <div
                class="
                p-0  md:w-6/12 lg:w-6/12 flex flex-wrap w-full glass
                transition duration-500 ease-in-out uppercase
                text-gray-600  bg-transparent border rounded-full transform 
                 hover:bg-gradient_nature1 hover:-translate-y-1 hover:scale-110
                 focus:bg-gradient_nature2 focus:-translate-y-1 focus:scale-110
                ">
                <button on:click={navigateToNature} class="w-full h-20">{$_("main.toNature")}</button>
            </div>
            <div
                class="
                p-0  md:w-6/12 lg:w-6/12 flex flex-wrap w-full glass
                transition duration-500 ease-in-out uppercase
                text-gray-600  bg-transparent border rounded-full transform 
                 hover:bg-gradient_culture1 hover:-translate-y-1 hover:scale-110
                 focus:bg-gradient_culture2 focus:-translate-y-1 focus:scale-110
                ">
                <button on:click={navigateToCulture} class="w-full h-20">{$_("main.toCulture")}</button>
            </div>
            <div
                class="
                p-0  md:w-6/12 lg:w-6/12 flex flex-wrap w-full glass
                transition duration-500 ease-in-out uppercase
                text-gray-600  bg-transparent border rounded-full transform 
                 hover:bg-gradient_world1 hover:-translate-y-1 hover:scale-110
                 focus:bg-gradient_world2 focus:-translate-y-1 focus:scale-110
                ">
                <button on:click={navigateToWorld} class="w-full h-20">{$_("main.toWorld")}</button>
            </div>
        </div>
    </div>
</section>
